<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M10.9035,7.5289l5.8627,-5.8627c0.1246,-0.1246,0.3266,-0.1246,0.4513,0l0.7891,0.7891c0.1246,0.1246,0.1246,0.3266,0,0.4513L13.413,7.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M19.0909,7.5H1.9195C1.6878,7.5,1.5,7.6878,1.5,7.9195v2.1566c0,0.2332,0.1908,0.424,0.424,0.424h0.5952c0.0009,0,0.0009,0.0071,0.002,0.0145l1.0885,8.3172c0.0564,0.3806,0.383,0.6683,0.7678,0.6683h12.2641c0.3812,0,0.7059,-0.2768,0.7664,-0.6532l1.1256,-8.3231c0.0017,-0.0104,0.002,-0.0237,0.0032,-0.0237h0.5437c0.2307,0,0.4195,-0.1888,0.4195,-0.4195V7.9091C19.5,7.6832,19.3168,7.5,19.0909,7.5z"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="10.5"
        x2="18.5"
        y2="10.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <circle
        cx="10.5"
        cy="9"
        r="0.7"
        fill="currentColor"
      />
      <rect
        x="9.5"
        y="14.5"
        width="2"
        height="2"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <rect
        x="5.5"
        y="14.5"
        width="2"
        height="2"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <rect
        x="13.5"
        y="14.5"
        width="2"
        height="2"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
